export const getPercentage = (percentage, base) =>
  Math.round((percentage * 100) / base)
